import { render, staticRenderFns } from "./EditUbicazione.vue?vue&type=template&id=b6074d0e&"
import script from "./EditUbicazione.vue?vue&type=script&lang=js&"
export * from "./EditUbicazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports